import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface IAppHeaderAction {
    action: string;
    application: string;
}

@Injectable({ providedIn: 'root' })
export class AppHeaderService {
    private readonly onAction: Subject<IAppHeaderAction> = new Subject();

    public setAction(action: IAppHeaderAction): void {
        this.onAction.next(action);
    }

    public getAction(): Observable<IAppHeaderAction> {
        return this.onAction.asObservable();
    }
}